import { render, staticRenderFns } from "./HsSwiper.vue?vue&type=template&id=5d06b5da&scoped=true"
import script from "./HsSwiper.vue?vue&type=script&lang=js"
export * from "./HsSwiper.vue?vue&type=script&lang=js"
import style0 from "./HsSwiper.vue?vue&type=style&index=0&id=5d06b5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06b5da",
  null
  
)

export default component.exports